import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UipathComponent} from './uipath/uipath.component';
import {BluePrismComponent} from './blue-prism/blue-prism.component';
import {AutomationAnywhereComponent} from './automation-anywhere/automation-anywhere.component';
import {SharedModule} from 'app/shared/shared.module';
import {BotsListComponent} from './shared/bots-list/bots-list.component';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import {BotConfigurationComponent} from './shared/bot-configuration/bot-configuration.component';
import {UipathConfigurationComponent} from './uipath/uipath-configuration/uipath-configuration.component';
import {BotProcessesComponent} from './shared/bot-processes/bot-processes.component';
import {BotProcessesAaeComponent} from './automation-anywhere/bot-processes-aae/bot-processes-aae.component';
import {BluePrismConfigurationComponent} from './blue-prism/blue-prism-configuration/blue-prism-configuration.component';
import {RpaBotsService} from './core/rpa-bots.service';
import {StoreModule} from '@ngrx/store';
import {RPA_GLOBAL_REDUCER} from './core/rpa-bots-feature.reducer';
import {UiPathDetailWrapperComponent} from './uipath/uipath-detail-wrapper/uipath-detail-wrapper.component';
import {AutomationDetailWrapperComponent} from './automation-anywhere/automation-detail-wrapper/automation-detail-wrapper.component';
import {BluePrismDetailWrapperComponent} from './blue-prism/blue-prism-detail-wrapper/blue-prism-detail-wrapper.component';
import {BotsEmptyComponent} from './shared/bots-empty-list/bots-empty.component';
import {UipathDashboardWrapperComponent} from './uipath/dashboard/uipath-dashboard-wrapper/uipath-dashboard-wrapper.component';
import {UipathRetriesWrapperComponent} from './uipath/retries/uipath-retries-wrapper/uipath-retries-wrapper.component';
import {UipathJobDashboardComponent} from './uipath/dashboard/dashboard-types/uipath-job-dashboard/uipath-job-dashboard.component';
import {UipathQueueitemDashboardComponent} from './uipath/dashboard/dashboard-types/uipath-queueitem-dashboard/uipath-queueitem-dashboard.component';
import {UipathJobRetriesComponent} from './uipath/retries/retries-types/uipath-job-retries/uipath-job-retries.component';
import {UipathQueueitemRetriesComponent} from './uipath/retries/retries-types/uipath-queueitem-retries/uipath-queueitem-retries.component';
import {LineChartComponent} from './uipath/common-components/charts/line-chart/line-chart.component';
import {PieChartComponent} from './uipath/common-components/charts/pie-chart/pie-chart.component';
import {CustomPaginatorLabels} from './uipath/retries/customPaginatorLabels'
import {
  BzgPaginatorModule,
  BzgTabsModule,
  BzgButtonModule,
  // BzgFormsModule,
  BzgHeaderModule,
  BzgIconModule,
  PaginatorLabelsService
} from 'bz-genome-angular';
import {DetailJobsModalComponent} from './uipath/common-components/modals/detail-jobs-modal/detail-jobs-modal.component';
import {DetailConfirmJobsModalComponent} from './uipath/common-components/modals/detail-confirm-jobs-modal/detail-confirm-jobs-modal.component';
import {DetailQueueitemsModalComponent} from './uipath/common-components/modals/detail-queueitems-modal/detail-queueitems-modal.component';
import {EditBotComponent} from './automation-anywhere/edit-bot/edit-bot.component';
import {DetailConfirmQueueitemsModalComponent} from './uipath/common-components/modals/detail-confirm-queueitems-modal/detail-confirm-queueitems-modal.component';
import { ConfirmModalComponent } from './uipath/common-components/confirm-modal/confirm-modal.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  declarations: [
    UipathComponent,
    BluePrismComponent,
    AutomationAnywhereComponent,
    BotsListComponent,
    BotConfigurationComponent,
    UipathConfigurationComponent,
    BotProcessesComponent,
    BotProcessesAaeComponent,
    BotProcessesAaeComponent,
    BluePrismConfigurationComponent,
    UiPathDetailWrapperComponent,
    AutomationDetailWrapperComponent,
    BluePrismDetailWrapperComponent,
    BotsEmptyComponent,
    UipathDashboardWrapperComponent,
    UipathRetriesWrapperComponent,
    UipathJobDashboardComponent,
    UipathQueueitemDashboardComponent,
    UipathJobRetriesComponent,
    UipathQueueitemRetriesComponent,
    LineChartComponent,
    PieChartComponent,
    DetailJobsModalComponent,
    DetailConfirmJobsModalComponent,
    DetailQueueitemsModalComponent,
    DetailConfirmQueueitemsModalComponent,
    EditBotComponent,
    ConfirmModalComponent
  ],
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    StoreModule.forFeature('rpaState', RPA_GLOBAL_REDUCER),
    CommonModule,
    FormsModule,
    SharedModule,
    BzgPaginatorModule,
    BzgTabsModule,
    BzgButtonModule,
    // BzgFormsModule,
    BzgHeaderModule,
    BzgIconModule,
    ReactiveFormsModule,
    NgxJsonViewerModule
  ],
  providers: [{ provide: PaginatorLabelsService, useClass: CustomPaginatorLabels},RpaBotsService],
  schemas : [CUSTOM_ELEMENTS_SCHEMA]
})
export class RpaBotsModule {
}
